import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import ThemeContext from './contexts/ThemeContext.tsx';

import '@fontsource-variable/albert-sans';
import '@fontsource-variable/fira-code';
import '@fontsource-variable/bitter';

import './main.css';

async function enableMocking() {
  if (import.meta.env.MODE !== 'msw') {
    return;
  }
}

const preferredLocale = localStorage.getItem('preferredLocale') || 'sv';
document.documentElement.lang = preferredLocale;
document.documentElement.setAttribute('xml:lang', preferredLocale);
document.body.lang = preferredLocale;
document.body.setAttribute('xml:lang', preferredLocale);

enableMocking().then(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <ThemeContext>
        <App />
      </ThemeContext>
    </React.StrictMode>,
  );
});
